module.exports = __webpack_public_path__ + "static/img/banner.376d9262.png";